import { render, staticRenderFns } from "./StyledToggleRefinement.vue?vue&type=template&id=82743422&scoped=true&"
import script from "./StyledToggleRefinement.vue?vue&type=script&lang=js&"
export * from "./StyledToggleRefinement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82743422",
  null
  
)

export default component.exports